import { Css, NodeDataDefinition } from 'cytoscape';

export interface GraceThdSynopticNodeDataDefinition extends NodeDataDefinition {
    classes: string[];

    data: SynopticNodeData;
}

export interface GenericSynopticNodeDataDefinition extends NodeDataDefinition {
    classes: string[];

    data: GenericSynopticNodeData;
}

export interface GenericSynopticNodeData extends SynopticNodeData {
    text_1: string;
    text_2: string;
    text_3: string;
    text_4: string;
    text_5: string;
    text_6: string;
    text_7: string;
    text_8: string;
}

export interface SynopticNodeData {
    address?: string;

    advancement?: string;

    boxLabel?: string;

    codeExt?: string;

    dataId?: string;

    externalCode: string;

    graceIdentifier?: string;

    id: string;

    incomingFibersByFunction?: string;

    label: string;

    logicalCodeType: string;

    logicalType?: string;

    nbPto?: number;

    numberVirtualRealCassettes?: string;

    outgoingFibersByFunction?: string;

    physicalType?: string;

    technicalPointType?: string;

    tiroir?: string;

    title: string;

    type: string;

    typeCode: string;

    typephyParent?: string;

    uuid: string;
}

export type SynopticStyleDefinition = {
    selector: string;
    style: Css.Node | Css.Edge | Css.Core;
};

export type FiberByFunction = {
    enteringFibers: number;
    function: string;
    outgoingFibers: number;
};

export enum AvancementCodeEnum {
    Discarded = 'A',
    Existing = 'E',
    Maintenance = 'T',
    NotWorking = 'H',
    ToCreate = 'C',
    Unknown = 'UNKNOWN',
    Working = 'S',
}

export enum AvancementCssClass {
    Discarded = 'discarded',
    Existing = 'existing',
    Maintenance = 'maintenance',
    NotWorking = 'not-working',
    ToCreate = 'to-create',
    Unknown = 'unknown',
    Working = 'working',
}

export enum AvancementLabelEnum {
    Discarded = 'synoptic.advancementLabel.discarded',
    Existing = 'synoptic.advancementLabel.existing',
    Maintenance = 'synoptic.advancementLabel.maintenance',
    NotWorking = 'synoptic.advancementLabel.notWorking',
    ToCreate = 'synoptic.advancementLabel.toCreate',
    Unknown = 'synoptic.advancementLabel.unknown',
    Working = 'synoptic.advancementLabel.working',
}

export enum Direction {
    From = 'from',
    To = 'to',
}

export enum FiberDirection {
    Entering = 'enteringFibers',
    Outgoing = 'outgoingFibers',
}

export enum NodeType {
    BAIE = 'BAIE',
    BPE = 'BPE',
    BPI = 'BPI',
    EDGE = 'edge',
    FERME = 'FERME',
    NRO = 'NRO',
    PB = 'PB',
    PBO = 'PBO',
    SRO = 'SRO',
}
